<template>
    <v-app>
      <v-container v-if = "esAccesoInvalido">
        <AccesoInvalido/>
      </v-container>
      <v-container v-else>
        <v-card class = "camposCuenta pb-10 pt-10 pl-10 pr-10" :max-width="600" >
            <v-form ref = "form">
                <v-text-field
                    v-model = "nombreUser"
                    label = "Nombre"
                    required>
                </v-text-field>
                <v-text-field
                    v-model = "docUser"
                    label = "Nro Documento"
                    :counter = "8"
                    required>
                </v-text-field>
                <v-text-field
                    v-model = "emailUser"
                    label = "Email"
                    :rules = "reglasE"
                    required>
                </v-text-field>
                <v-text-field
                  v-model="usuario"
                  label="Usuario">
                </v-text-field>
                <v-text-field
                  v-model="password"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Contraseña"
                  hint="Minimo 8 caracteres"
                  @click:append="show1 = !show1">
                </v-text-field>
            </v-form>
            <v-row class ="botoneraCuenta">
              <div class="flex-grow-1"></div>
              <v-btn @click = "guardarDatos()" color="#51D6CC">Aceptar</v-btn>
              <v-btn color="#51D6CC">Cancelar</v-btn>
              <v-btn @click="cancelarCuenta()" v-if = "1!=1">Cancelar cuenta</v-btn>
            </v-row>
        </v-card>
      </v-container>
      <v-snackbar
      v-model = "warning"
      bottom
      color = "error">
      {{ text }}
      <v-btn dark text @click = "warning = false"> Aceptar </v-btn>
    </v-snackbar>
    <v-dialog v-model = "dialogRemove" max-width="500">
      <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>Atención</v-card-title>
          <div v-if = "loading == true">
            <v-card-text>
              Eliminando cuenta...
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-text>
              ¿Desea eliminar esta cuenta? Esta acción no podrá deshacerse.
            </v-card-text>
            <v-card-actions>
              <div class ="flex-grow-1"></div>
              <v-btn @click = "eliminarCuenta()">Aceptar</v-btn>
              <v-btn @click = "dialogRemove = false">Cancelar</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model ="dialog"  max-width="500">
        <template v-slot:activator="{ on }"></template>
        <v-card>
          <v-card-title>Cambios guardados</v-card-title>
          <v-card-text>
            Los cambios se han guardado exitosamente
          </v-card-text>
          <v-card-actions>
            <div class ="flex-grow-1"></div>
            <v-btn @click = "dialog = false">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app>
</template>
<style>
.camposCuenta {
    margin-left: 50px;
}
.botoneraCuenta{
    margin-top: 20px;
}
.v-btn{
  margin-left: 5px;
}
</style>
<script>
import axios from 'axios';
import AccesoInvalido from '@/components/AccesoInvalido.vue';
import { url } from '@/variables';

export default {
  components: {
    AccesoInvalido,
  },
  data() {
    return {
      show1: false,
      dialog: false,
      url: global.url,
      nombreUser: '',
      docUser: '',
      emailUser: '',
      usuario: '',
      password: '',
      esAccesoInvalido: false,
      reglasE: [
        v => !!v || 'El email es obligatorio.',
        v => /.+@.+\..+/.test(v) || 'El email debe ser válido.',
      ],
      text: 'Debe completar los campos vacíos',
      warning: false,
      dialogRemove: false,
      loading: false,
    };
  },
  methods: {
    init() {
      const path = `${url}/getDatosCuenta`;
      axios.post(path, {
        id: this.$session.get('id'),
        token: this.$session.get('token'),
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.msg !== 'Ok') {
              this.$session.set('id', '0');
              this.$session.remove('token');
              this.$router.push('/');
            } else
            if (response.data.datos.length > 0) {
              const d = response.data.datos[0];
              this.nombreUser = d.nombre;
              this.docUser = d.nrodoc;
              this.emailUser = d.email;
              this.usuario = d.usuarioweb;
            }
          }
        });
    },
    guardarDatos() {
      if (this.$refs.form.validate()) {
        const path = `${url}/guardarDatos`;
        axios.post(path, {
          id: this.$session.get('id'),
          token: this.$session.get('token'),
          nombre: this.nombreUser,
          doc: this.docUser,
          email: this.emailUser,
          passw: this.password,
        })
          .then((response) => {
            if (response.status === 200) {
              this.dialog = true;
            }
          });
      } else {
        this.warning = true;
      }
    },
    cancelarCuenta() {
      this.dialogRemove = true;
    },
    eliminarCuenta() {
      this.loading = true;
      const path = `${url}/eliminarCuenta`;
      axios.post(path, {
        id: this.$session.get('id'),
        token: this.$session.get('token'),
        mail: this.emailUser,
        nombre: this.nombreUser,
      })
        .then((response) => {
          if (response.status === 200) {
            this.loading = false;
            this.dialogRemove = false;
            this.$session.set('id', '0');
            this.$session.remove('token');
            this.$router.push('/');
          }
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>
